<template>
  <div style="overflow-x: hidden; overflow-y: hidden; position: relative;" class="pb-1">
    <div v-if="generics && generics.length > 0">
      <div
        style="margin: 0; padding: 0; margin-left: 10px; margin-right: 10px;"
        :style="{
          'padding-bottom': size == 'small' ? '0px' : '25px',
          'justify-content': align == 'left' ? 'flex-start' : 'flex-end'
        }"
      >
        <v-btn
          class="mx-2"
          fab
          small
          style="align-self: center; position: absolute; z-index: 1; top: 35%; left: -3px;"
          v-if="currentState !== 0"
          @click="currentState = currentState - 1"
        >
          <i style="font-size: 20px" class="fa fa-angle-left" aria-hidden="true"></i>
        </v-btn>

        <v-btn
          v-if="currentState + 1 !== generics.length"
          class="mx-2"
          fab
          small
          style="    align-self: center;
          position: absolute;
          z-index: 1;
          top: 35%;"
          :style="{
            left: size == 'small' ? '177px' : '277px'
          }"
          @click="currentState = currentState + 1"
        >
          <i style="font-size: 20px" class="fa fa-angle-right" aria-hidden="true"></i>
        </v-btn>
        <!-- <template v-for="(generic, index) in generics"> -->
        <generic-viewer-item
          @openShopModel="openShopModel"
          @clickBtnMessage="clickBtnMessage"
          :isBotTest="isBotTest"
          :ratio="ratio"
          :generic="generics[currentState]"
          :key="'generic_'"
          :size="size"
        ></generic-viewer-item>
        <!-- </template> -->
      </div>
    </div>
  </div>
</template>

<script>
import GenericViewerItem from './GenericViewerItem'
export default {
  props: {
    isBotTest: { type: Boolean, default: false },
    value: [Object, String, Array],
    size: {
      type: String,
      default: 'big'
    },
    align: {
      default: 'left'
    },
    ratio: {
      default: 'square'
    }
  },
  methods: {
    clickBtnMessage(button) {
      this.$emit('clickBtnMessage', button)
    },
    openShopModel(url) {
      this.$emit('openShopModel', url)
    }
  },
  components: {
    GenericViewerItem
  },
  computed: {
    genericsLength: function() {
      var count = 0
      return this.generics.length
    }
  },
  data: function() {
    return {
      generics: this.value,
      currentState: 0
    }
  },
  watch: {
    value: function() {
      this.generics = this.value
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/elements/GenericViewer.vue